import { render, staticRenderFns } from "./orderSearch.vue?vue&type=template&id=53cc70bb"
import script from "./orderSearch.vue?vue&type=script&lang=js"
export * from "./orderSearch.vue?vue&type=script&lang=js"
import style0 from "./orderSearch.vue?vue&type=style&index=0&id=53cc70bb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports